import React from 'react';
import { Text, i18n, tokens, Theme } from '@simplybenefits/sb-ui-library';
import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import ContentBlock from '../components/ContentBlock.js';
import { getFYIDoctorsSections } from './FYIDoctors.constants.js';

const styles = {
    accordionBase: {
        backgroundColor: Theme.colors.surface,
        boxShadow: 'none',
        '&:before': { display: 'none' }, // Removes MUI's default divider line
        borderTop: '1px solid #e6e7e8',
        '&:first-of-type': { borderTop: 'none' } // no top border for the first item in the list
    },
    summary: {
        '&.MuiAccordionSummary-root': { // align summary text to the left by removing internal padding
            padding: 0
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
            color: Theme.colors.mainTextGrey,
            width: 24,
            height: 75,
            alignItems: "center" // ensure spinning icon stays centered
        }
    },
    details: {
        padding: 0, // align details text to the left by removing internal padding
        '& ol': {
            paddingLeft: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }
};

/**
 * Helper to render sections
 * @param {Object} section - Section configuration object
 * @param {string} section.title - Translated section title
 * @param {string[]} section.items - Array of translated list items
 * @param {boolean} [section.isLast=false] - Whether this is the last section
 * @returns {JSX.Element}
 */
const renderSection = ({ title, items, isLast = false }) => (
    <Accordion
        sx={{
            ...styles.accordionBase,
            ...(isLast && { borderBottom: '1px solid #e6e7e8' })
        }}
    >
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={styles.summary}
        >
            <Text medium bold>{i18n.t(title)}</Text>
        </AccordionSummary>

        <AccordionDetails sx={styles.details}>
            <ol>
                {
                    items.map((item, index) => (
                        <Text key={index}>
                            <li>
                                {i18n.t(item)}
                            </li>
                        </Text>
                    ))
                }
            </ol>
        </AccordionDetails>
    </Accordion>
);

/**
 * FYI Doctors Terms and Conditions component
 * @returns {JSX.Element}
 */
const FYIDoctorsTermsAndConditions = () => {
    const TERMS_CONDITIONS_SECTIONS = getFYIDoctorsSections(i18n.locale);

    return (
        <ContentBlock>
            <Grid item xs={12}>
                <Text large bold customStyle={{ marginBottom: 15 }}>
                    {i18n.t(tokens.labels.perks.fyiDoctorsTermsAndConditions)}
                </Text>

                {
                    TERMS_CONDITIONS_SECTIONS.map((section, index) => (
                        <React.Fragment key={index}>
                            {renderSection(section)}
                        </React.Fragment>
                    ))
                }

                <Text customStyle={{ marginTop: 35, marginBottom: 20 }}>
                    {i18n.t(tokens.labels.perks.fyiDoctorsParticipation)}
                </Text>
            </Grid>
        </ContentBlock>
    );
};

export default FYIDoctorsTermsAndConditions;